@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key && $.adata.type == 'email') {
    <span>{{ emailStatus[$.row[$.adata.fetch_key]] }}</span>
  }
  @if ($.row && $.adata.fetch_key && $.adata.type == 'sms') {
    <span>{{ smsTransactionLogStatus[$.row[$.adata.fetch_key]] }}</span>
  }
  @if ($.row && $.adata.fetch_key && $.adata.type == 'whatsapp') {
    <span>{{
      whatsappMessageTransactionLogStatus[$.row[$.adata.fetch_key]]
    }}</span>
  }
}
